var _path, _path2, _g, _path3, _path4, _g2, _path5, _g3, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTogetherWActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 25,
    viewBox: "0 0 50 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8138 8.108C28.8141 8.92101 28.5734 9.71587 28.122 10.392C27.6706 11.0682 27.0288 11.5953 26.2777 11.9067C25.5267 12.218 24.7002 12.2996 23.9028 12.1412C23.1054 11.9828 22.3729 11.5914 21.7979 11.0166C21.2229 10.4417 20.8314 9.70933 20.6727 8.91194C20.5141 8.11456 20.5955 7.28804 20.9067 6.53694C21.2179 5.78584 21.7448 5.14389 22.4209 4.69231C23.0969 4.24073 23.8917 3.9998 24.7048 4C25.7943 4.00027 26.8391 4.43312 27.6096 5.20344C28.3801 5.97375 28.8132 7.01848 28.8138 8.108Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2619_6837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 16,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1797 14.3936H32.2287V21.9196H17.1797V14.3936Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2619_6837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1797 21.9196C17.1797 19.9233 17.9727 18.0088 19.3843 16.5972C20.7959 15.1856 22.7104 14.3926 24.7067 14.3926C26.703 14.3926 28.6175 15.1856 30.0291 16.5972C31.4407 18.0088 32.2337 19.9233 32.2337 21.9196H17.1797Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1949 8.10868C18.1951 8.65519 18.0333 9.18949 17.7298 9.64399C17.4263 10.0985 16.9948 10.4528 16.49 10.6621C15.9851 10.8713 15.4296 10.9262 14.8935 10.8197C14.3575 10.7132 13.8651 10.4501 13.4786 10.0638C13.0921 9.6774 12.8288 9.18508 12.7221 8.64908C12.6154 8.11309 12.6701 7.55749 12.8792 7.05256C13.0883 6.54763 13.4424 6.11605 13.8968 5.8124C14.3512 5.50875 14.8854 5.34668 15.4319 5.34668C16.1646 5.34668 16.8672 5.63764 17.3853 6.15559C17.9035 6.67354 18.1947 7.37606 18.1949 8.10868Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2619_6837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 12,
    width: 16,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.3438H23.049V19.8698L8.492 18.1438L8 12.3438Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2619_6837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5062 18.1219C15.0002 18.1219 9.49219 18.1439 9.49219 18.1439C9.51528 17.366 9.69206 16.6003 10.0124 15.8909C10.3326 15.1816 10.7901 14.5426 11.3584 14.0109C11.9267 13.4791 12.5946 13.065 13.3236 12.7925C14.0527 12.5199 14.8284 12.3944 15.6062 12.4229C17.0289 12.4124 18.4221 12.8283 19.6062 13.6169C18.5743 13.9177 17.6455 14.4974 16.9221 15.2923C16.1986 16.0872 15.7087 17.0664 15.5062 18.1219Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2619_6837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 12,
    width: 16,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0785 18.4231L26.5215 20.149V12.623H41.5705L41.0785 18.4231Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2619_6837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9668 13.8953C31.1512 13.1074 32.5443 12.692 33.9668 12.7023C37.7478 12.7763 40.1398 14.9023 40.0808 18.4223C40.0808 18.4223 34.5738 18.3973 34.0668 18.4013C33.8645 17.3456 33.3746 16.3662 32.6512 15.5711C31.9277 14.776 30.9988 14.1961 29.9668 13.8953Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8258 8.10868C36.8258 8.65495 36.6638 9.18896 36.3603 9.64316C36.0568 10.0974 35.6254 10.4514 35.1207 10.6604C34.616 10.8695 34.0607 10.9242 33.5249 10.8176C32.9891 10.711 32.497 10.448 32.1107 10.0617C31.7245 9.67544 31.4614 9.18329 31.3548 8.64752C31.2483 8.11174 31.303 7.5564 31.512 7.05171C31.7211 6.54702 32.0751 6.11565 32.5293 5.81216C32.9835 5.50867 33.5175 5.34668 34.0638 5.34668C34.4265 5.34668 34.7856 5.41812 35.1207 5.55692C35.4558 5.69573 35.7603 5.89918 36.0168 6.15565C36.2733 6.41213 36.4767 6.71661 36.6155 7.05171C36.7543 7.38681 36.8258 7.74597 36.8258 8.10868Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTogetherWActive);
export default __webpack_public_path__ + "static/media/menu_together_w_active.24fba0d4ee2aca2b096154aaf6a6ba69.svg";
export { ForwardRef as ReactComponent };